import { Observable, Subject } from "rxjs";
import { ConfigService } from "../config/config.service";
import { Inject, Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";

@Injectable()
export class JackpotCounterService {
    private subjectObs = new Subject<any>();
    constructor(
        @Inject(HttpClient) private http: HttpClient,
        private config:ConfigService
    ) {}

    sendCounterValue(counterData) {
        this.subjectObs.next(counterData);
    }

    getCounterValueAsObservable(): Observable<any> {
        return this.subjectObs.asObservable();
    }

    getMicrogamingDataAPI(moduleID, currency){
        let params = new URLSearchParams();
        params.set("moduleId", moduleID);
        params.set("currency", currency);
        let URL = this.config.getEnv().webservices_url + "/external/microgaming-jackpot" + params.toString();
        return this.http.get(URL);
    }

    getNetEntDataAPI(jackpotId){ 
        let params = new URLSearchParams();
        params.set("jackpotId", jackpotId);
        // options.params.set("currency", currency);
        let URL = this.config.getEnv().webservices_url + "/external/netent-jackpot" + params.toString();
        return this.http.get(URL);
    }

    getEvolutionDataAPI(jackpotId){ 
        let params = new URLSearchParams();
        params.set("jackpotId", jackpotId);
        // options.params.set("currency", currency);
        let URL = this.config.getEnv().webservices_url + "/external/evolution-jackpot" + params.toString();
        return this.http.get(URL);
    }
}
